import {GlobalVariables} from "../GlobalVariables";

export default class PageSingleProgram {
	constructor() {

		if( !document.body.classList.contains('single-program') ){
			return;
		}

		const mainSlider = document.querySelector('.single-program-main-slider');

		if( !mainSlider ){
			return;
		}

		const swiper = mainSlider.querySelector('.swiper');
		const prev = mainSlider.querySelector(".navigation-button-prev");
		const next = mainSlider.querySelector(".navigation-button-next");
		new Swiper(swiper, {
			slidesPerView: 1,
			spaceBetween: 34,
			grabCursor: true,
			speed: 800,
			navigation: {
				prevEl: prev,
				nextEl: next,
			}
		});

		let tableHead = document.querySelectorAll('.table-header-collapse');
		tableHead.forEach( ( item ) => {
			let tableBody = item.nextElementSibling;
			if (tableBody && tableBody.classList.contains('table-body-collapse')) {
				const tableType = item.querySelector('.table-head-type').innerHTML;
				const tableLines = tableBody.querySelectorAll('.table-line');
				const tableNumber = item.querySelector('.table-head-number');
				tableNumber.innerHTML = `${tableLines.length} ${tableType} disponibles`;
			}
		});

		let demandPlan = document.querySelectorAll('.js-plan');
		let formPlan = document.querySelector('.form-plan');
		let formInputProgram = formPlan.querySelector('input[name="input_20"]');
		let formInputLot = formPlan.querySelector('input[name="input_21"]');
		demandPlan.forEach( (plan) => {
			plan.addEventListener( "click" , (e) => {
				GlobalVariables.lenis?.stop();
				e.preventDefault();
				document.body.classList.add('form-plan-open');

				let program = plan.dataset.program;
				let lot = plan.dataset.lot;
				formInputProgram.value = program;
				formInputLot.value = lot;
			});
		});

		let formOverlay = document.querySelector('.single-program-aside-form-overlay');
		formOverlay.addEventListener( "click" , (e) => {
			e.preventDefault();
			document.body.classList.remove('form-plan-open');
			GlobalVariables.lenis?.start();
		});

		let formClose = document.querySelector('.single-program-aside-form-close');
		formClose.addEventListener( "click" , (e) => {
			e.preventDefault();
			document.body.classList.remove('form-plan-open');
			GlobalVariables.lenis?.start();
		});

	}
}
